var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        ["payment-method-popup"]: true,
        ["hide"]: _vm.popupOpen !== "paymentMethod",
      },
    },
    [
      _c("div", { ref: "paymentMethodPopup", staticClass: "popup" }, [
        _c("div", { staticClass: "title-section" }, [
          _c("h2", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "dash.settings.billing.card.billing_information.method.title"
                )
              )
            ),
          ]),
          _c("p", [
            _vm._v(_vm._s(_vm.$t("dash.settings.billing.addMethod.subtitle"))),
          ]),
        ]),
        _c("div", { staticClass: "content-form" }, [
          _c(
            "div",
            {
              staticClass: "card",
              class: [{ open: _vm.methodChoice == "card" }],
            },
            [
              _c(
                "header",
                {
                  on: {
                    click: function ($event) {
                      _vm.methodChoice = "card"
                    },
                  },
                },
                [
                  _vm._m(0),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "dash.settings.billing.addMethod.method_card.title"
                        )
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "fa-brands fa-cc-visa" }),
                  _c("div", { staticClass: "fa-brands fa-cc-mastercard" }),
                ]
              ),
              _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "container-input number-card" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "dash.settings.billing.addMethod.method_card.number_card"
                        )
                      )
                    ),
                  ]),
                  _vm._m(1),
                  _c("div", { staticClass: "error" }, [
                    _vm.cardNumberError
                      ? _c("i", {
                          staticClass: "fa-regular fa-circle-exclamation",
                        })
                      : _vm._e(),
                    _vm._v(_vm._s(_vm.cardNumberError)),
                  ]),
                ]),
                _c("div", { staticClass: "container-input name-card" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "dash.settings.billing.addMethod.method_card.name_card"
                        )
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "input" }, [
                    _c("i", { staticClass: "fa-regular fa-circle-user" }),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.nameCardValue,
                          expression: "nameCardValue",
                        },
                      ],
                      attrs: { placeholder: "ex. John Smith" },
                      domProps: { value: _vm.nameCardValue },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.nameCardValue = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "error" }, [
                    _vm.cardNameError
                      ? _c("i", {
                          staticClass: "fa-regular fa-circle-exclamation",
                        })
                      : _vm._e(),
                    _vm._v(_vm._s(_vm.cardNameError)),
                  ]),
                ]),
                _c("div", { staticClass: "last-line" }, [
                  _c("div", { staticClass: "container-input expire-card" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "dash.settings.billing.addMethod.method_card.expire_card"
                          )
                        )
                      ),
                    ]),
                    _vm._m(2),
                  ]),
                  _c("div", { staticClass: "container-input key-card" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "dash.settings.billing.addMethod.method_card.security_card"
                          )
                        )
                      ),
                    ]),
                    _vm._m(3),
                  ]),
                ]),
                _c("div", { staticClass: "error" }, [
                  _vm.stripeError || _vm.cardExpiryError || _vm.cardCvcError
                    ? _c("i", {
                        staticClass: "fa-regular fa-circle-exclamation",
                      })
                    : _vm._e(),
                  _vm._v(
                    _vm._s(
                      _vm.stripeError || _vm.cardExpiryError || _vm.cardCvcError
                    )
                  ),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "card",
              class: [{ open: _vm.methodChoice == "sepa" }],
            },
            [
              _c(
                "header",
                {
                  on: {
                    click: function ($event) {
                      _vm.methodChoice = "sepa"
                    },
                  },
                },
                [
                  _vm._m(4),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "dash.settings.billing.addMethod.method_sepa.title"
                        )
                      )
                    ),
                  ]),
                ]
              ),
              _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "container-input name-card" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "dash.settings.billing.addMethod.method_sepa.name"
                        )
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "input" }, [
                    _c("i", { staticClass: "fa-regular fa-circle-user" }),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.nameIbanValue,
                          expression: "nameIbanValue",
                        },
                      ],
                      attrs: { placeholder: "ex. John Smith", required: "" },
                      domProps: { value: _vm.nameIbanValue },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.nameIbanValue = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "error" }, [
                    _vm.nameIbanError
                      ? _c("i", {
                          staticClass: "fa-regular fa-circle-exclamation",
                        })
                      : _vm._e(),
                    _vm._v(_vm._s(_vm.nameIbanError)),
                  ]),
                ]),
                _c("div", { staticClass: "container-input email-card" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "dash.settings.billing.addMethod.method_sepa.email"
                        )
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "input" }, [
                    _c("i", { staticClass: "fa-regular fa-envelope" }),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.emailIbanValue,
                          expression: "emailIbanValue",
                        },
                      ],
                      attrs: {
                        placeholder: "ex. john.smith@example.com",
                        required: "",
                      },
                      domProps: { value: _vm.emailIbanValue },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.emailIbanValue = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "error" }, [
                    _vm.emailIbanError
                      ? _c("i", {
                          staticClass: "fa-regular fa-circle-exclamation",
                        })
                      : _vm._e(),
                    _vm._v(_vm._s(_vm.emailIbanError)),
                  ]),
                ]),
                _c("div", { staticClass: "container-input iban" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "dash.settings.billing.addMethod.method_sepa.iban"
                        )
                      )
                    ),
                  ]),
                  _vm._m(5),
                  _c("div", { attrs: { id: "mandate-acceptance" } }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.$t(
                            "dash.settings.billing.addMethod.method_sepa.mandat_acceptance"
                          )
                        ) +
                        "\n                        "
                    ),
                  ]),
                  _c("div", { staticClass: "error" }, [
                    _vm.ibanError
                      ? _c("i", {
                          staticClass: "fa-regular fa-circle-exclamation",
                        })
                      : _vm._e(),
                    _vm._v(_vm._s(_vm.ibanError)),
                  ]),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "card",
              class: [{ open: _vm.methodChoice == "paypal" }],
            },
            [
              _c(
                "header",
                {
                  on: {
                    click: function ($event) {
                      _vm.methodChoice = "paypal"
                    },
                  },
                },
                [
                  _vm._m(6),
                  _c("p", [_vm._v("Paypal")]),
                  _c("div", { staticClass: "fa-brands fa-cc-paypal" }),
                ]
              ),
            ]
          ),
          _c("div", { staticClass: "btns" }, [
            _c(
              "div",
              { staticClass: "btn-outline-primary", on: { click: _vm.cancel } },
              [_vm._v(_vm._s(_vm.$t("dash.button.cancel")))]
            ),
            _c(
              "div",
              {
                staticClass: "btn-primary icon-r",
                on: { click: _vm.submitFormToCreateToken },
              },
              [_vm._v(_vm._s(_vm.$t("dash.button.add")))]
            ),
          ]),
        ]),
        _c("div", { staticClass: "content-loading", attrs: { hidden: "" } }, [
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("dash.settings.billing.addMethod.method_card.loading")
              )
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "circle active" }, [_c("div")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input" }, [
      _c("i", { staticClass: "fa-regular fa-credit-card" }),
      _c("div", { staticClass: "inputStripe", attrs: { id: "card-number" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input" }, [
      _c("i", { staticClass: "fa-regular fa-calendar" }),
      _c("div", { staticClass: "inputStripe", attrs: { id: "card-expiry" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input" }, [
      _c("i", { staticClass: "fa-regular fa-key" }),
      _c("div", { staticClass: "inputStripe", attrs: { id: "card-cvc" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "circle active" }, [_c("div")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input" }, [
      _c("i", { staticClass: "fa-regular fa-credit-card" }),
      _c("div", { staticClass: "inputStripe", attrs: { id: "iban-element" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "circle" }, [_c("div")])
  },
]
render._withStripped = true

export { render, staticRenderFns }